import {Progress } from 'reactstrap';
import styled from 'styled-components';
import { ProgressState } from '../../features/ingest/ingestSlice';

const ProgressBar = styled(Progress)`
  height: 2em;
  border-radius: 5px;
`;

export default (props:ProgressState) => {
    return (
    <div style={{ paddingBottom: '4em' }}>
        <ProgressBar animated color="info" value={props.value}>
        <span>{props.message}</span>
        </ProgressBar>
    </div>
    );
};
 